








































































import Modal from './Base.vue';
import { Component, Mixins, Vue, Prop, Watch } from 'vue-property-decorator';
import TextField from '@/components/Form/TextField.vue';
import User from '@/services/User';
import Autocomplete from 'vuejs-auto-complete';
import ClaimForm from '@/services/ClaimForm';
import { Getter, State } from 'vuex-class';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
// Services
import Claims from '@/services/Claims';
import * as Sentry from '@sentry/browser';
import ActiveDirectory, { ClaimConsultant } from '@/services/ActiveDirectory';
import { IUser } from '@/common/Auth';

@Component({
	name: 'ConfirmPayment',
	components: {
		Modal,
		TextField,
		Autocomplete,
	},
})
export default class EmailClaimForm extends Vue {
	@State('user', { namespace: 'Auth' }) private user: IUser | undefined;

	@Prop() private claimId: string;
	@Prop() private emailStatus: string;
	@Prop() private insuredName: string;
	@Prop() private loading: boolean;

	private ccEmailsList = [];
	private comments: string = '';
	private email: string = '';
	private emails: ClaimConsultant[] = [];
	private files: any[] = [];
	private subject: string = 'Loss Notice';

	private close() {
		(this.$refs.emailClaimFormModal as any).closeModal();
	}

	private async created() {
		this.emails = await ActiveDirectory.getClaimConsultants('ClaimAll');
		this.emails = this.emails.filter(
			consultant => consultant.givenName !== null && consultant.surName !== null,
		);
	}

	private emailSelected(value) {
		this.email = value.selectedObject.email;
		this.ccEmailsList.push(value.selectedObject.email);
	}

	private ccEmailSelected(value) {
		this.ccEmailsList.push(value.selectedObject.email);
	}

	get getEmail() {
		return this.email;
	}

	private removeItem(email) {
		for (let i = 0; i <= this.ccEmailsList.length - 1; i++) {
			if (email === this.ccEmailsList[i]) {
				this.ccEmailsList.splice(i, 1);
			}
		}
	}
	private getCSVEmails() {
		let emails = '';
		this.ccEmailsList.forEach(email => {
			emails = emails === '' ? email : emails + ',' + email;
		});
		return emails;
	}

	private sendEmail() {
		this.generatePDFAndSendEmail();
		this.close();
	}

	private dataURLtoFile(dataurl, filename) {
		const arr = dataurl.split(',');
		const mime = arr[0].match(/:(.*?);/)[1];
		const bstr = atob(arr[1]);
		let n = bstr.length;
		const u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, { type: mime });
	}

	private async uploadClaimFormToS3(dataurl) {
		try {
			// Upload Files First and update claim data with uploaded url

			const file = this.dataURLtoFile(dataurl, 'LossNotice-' + this.insuredName);
			if (file) {
				const updatedFile: any = file;
				updatedFile.file_name = file.name;
				updatedFile.file_type = file.type;
				const files = [];
				files.push(updatedFile);
				const getPresignedUrls = await Claims.getPresignedUrls(files);

				console.log('getPresignedUrls', getPresignedUrls);
				const uploadedFile = await this.uploadFile(getPresignedUrls.data[0], updatedFile);
				console.log(uploadedFile);

				if (!uploadedFile.failed) {
					const update = await Claims.updateClaimDataWithClaimFormUrl(
						uploadedFile.fname,
						uploadedFile.fileLocation,
						uploadedFile.upload_url,
						this.claimId,
					);
				}
			}
		} catch (e) {
			Sentry.captureException(e);
			return;
		}
	}

	private async uploadFile(signedUrl, file) {
		// tslint:disable-next-line: prefer-const
		let uploadResponse = [];
		const currentFile = {
			file_name: signedUrl.fname,
			file_type: 'application/pdf',
			progress: 0,
			failed: false,
		};
		const config = {
			onUploadProgress: progressEvent => {
				Vue.nextTick(() => {
					currentFile.progress = Math.round(
						(progressEvent.loaded * 100) / progressEvent.total,
					);
				});
			},
		};
		try {
			const uploadedFile = await Claims.uploadFiles(signedUrl.upload_url, file, config);
			signedUrl.failed = false;
			uploadResponse.push(uploadedFile);
		} catch (e) {
			console.log(JSON.stringify(e));
			currentFile.failed = true;
			signedUrl.failed = true;
		}
		return signedUrl;
	}

	// TODO: WARNING! This PDF generation functionality is duplicated in Single.vue, but not quite
	// as nicely. There should be a single function that is called by both components to do the
	// work.
	private async generatePDFAndSendEmail() {
		this.$emit('update:loading', true);
		try {
			// TODO: Why is this needed?
			window.scrollTo(0, 0);

			// TODO: Why not just use jspdf.html() instead of all this code?

			// Capture the claim form's dimensions before it is hidden in favor of the "loading"
			// spinner.
			const claimForm = document.querySelector('#claimForm') as HTMLElement;

			// Temporarily replace the text area holding comments with a div presenting those same
			// comments, render the claim form as an image, and then restore the text area.
			let imageDataUrl: string;
			let imageWidth: number;
			let imageHeight: number;
			{
				const commentsTextArea = claimForm.querySelector(
					'#textAreaComments',
				) as HTMLTextAreaElement;
				const commentsDiv: HTMLDivElement = document.createElement('div');
				commentsDiv.innerHTML = commentsTextArea.value.replace(/\n/g, '<br />');
				commentsTextArea.replaceWith(commentsDiv);
				try {
					const canvas: HTMLCanvasElement = await html2canvas(claimForm);
					imageDataUrl = canvas.toDataURL('image/jpeg');
					imageWidth = canvas.width;
					imageHeight = canvas.height;
				} finally {
					commentsDiv.replaceWith(commentsTextArea);
				}
			}

			// Add the image to each page of a PDF, but with a negative vertical offset to make it
			// appear as though each page has a distinct region of the image. Note that no margins
			// are present as that would require the image to be clipped as it is added to the page.
			// Also note that the whole image is added to every page, when there could be a more
			// efficient way to draw just a portion of the image to a page or add the image once to
			// the document and then reference a region of it on each page.
			const pdfWidth: number = imageWidth;
			const pdfHeight: number = pdfWidth * 1.5;
			const pdf = new jspdf('p', 'pt', [pdfWidth, pdfHeight]);

			const pageCount = Math.ceil(imageHeight / pdfHeight);
			for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
				if (pageIndex > 0) {
					pdf.addPage(pdfWidth, pdfHeight);
				}
				pdf.addImage(
					imageDataUrl,
					'JPEG',
					0,
					-(pdfHeight * pageIndex),
					imageWidth,
					imageHeight,
				);
			}

			// Upload the document and trigger an email.
			await this.uploadClaimFormToS3(pdf.output('datauristring'));
			const sendData = {
				email: this.email,
				ccEmailsList: this.getCSVEmails(),
				comments: this.comments,
				subject: this.subject,
				claimId: this.claimId,
			};
			await ClaimForm.email(sendData);

			this.$emit('update:emailStatus', 'Claim Form has been emailed!');
		} catch (e) {
			this.$emit('update:emailStatus', 'There was an error in emailing the claim form!');
			Sentry.captureException(e);
		} finally {
			this.$emit('update:loading', false);
		}
	}
}
